import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import classNames from 'classnames';
import styles from './Summary.scss';

function Summary({
  title, label, fetching, price, form, disabled, dispatch,
}) {
  return (
    <div className={styles.root}>
      <span className={styles.package}>{title}</span>
      <span className={styles.price}>{price}</span>
      <button
        type="button"
        className={
          classNames(
            'ui-btn',
            'ui-btn_XL',
            'ui-btn_primary',
            { 'ui-btn_primary--disabled': disabled || fetching },
            styles.button,
          )
        }
        onClick={() => dispatch(submit(form))}
        disabled={disabled}
      >
        {
          fetching
            ? <span className={styles.spinner} />
            : <span>{ label === 'upgrade' ? 'Upgrade Now' : 'Renew Now' }</span>
        }
      </button>
    </div>
  );
}

export default compose(
  setDisplayName('Summary'),
  setPropTypes({
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    fetching: PropTypes.bool.isRequired,
    price: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
  }),
  connect(),
)(Summary);
